import { Button, Divider, Space, Table, TableProps } from "antd";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { BASE_API_URL } from "../../../utils/consts";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useAuth } from "../../../utils/useAuth";
import { useTranslation } from "react-i18next";
import { isAdmin } from "../../../utils/permissions";

type Props = {};

interface DataType {
  key: string;
  name: string;
  age: number;
  address: string;
  tags: string[];
}

const OvertimeSettings: React.FC<Props> = () => {
  const params = useParams();
  const { t } = useTranslation();
  const authUser: any = useAuth();
  const userData = useSelector((state: any) => state.userData.user);
  const [clientOvertimes, setClientOvertimes] = useState<any>(undefined);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const columns: TableProps<DataType>["columns"] = [
    {
      title: t("Overtime Name"),
      dataIndex: "overtimeName",
      key: "overtimeName",
    },
    // {
    //   title: t("activeType"),
    //   dataIndex: "activeType",
    //   key: "activeType",
    //   render: (text) => <a>{text}</a>,
    // },
    {
      title: t("deadline"),
      dataIndex: "deadline",
      key: "deadline",
    },

    {
      title: t("Action"),
      key: "action",
      render: (row, record) => (
        <Space size="middle">
          <Button
            onClick={() => {
              navigate(`/settings/overtime/${row._id}`);
            }}
          >
            {t("View")}
          </Button>
          <Button
            onClick={() => {
              axios
                .delete(`${BASE_API_URL}/admin/${row._id}/overtimeType_delete`)
                .then((res) => {
                  // dispatch(deleteWorkingPattern(row._id));
                  window.location.reload();
                })
                .catch((error) => console.error(error));
            }}
          >
            {t("Delete")}
          </Button>
        </Space>
      ),
    },
  ];

  useEffect(() => {
    if (params.id !== "new") {
      axios
        .get(`${BASE_API_URL}/admin/${userData?.clientId}/overtimes`)
        .then((res) => {
          setClientOvertimes(res.data);
        })
        .catch((error) => console.error(error));
    }
  }, [params.id]);

  return (
    <>
      {isAdmin(authUser.roles) && (
        <Button
          type="primary"
          onClick={() => navigate("/settings/overtime/new")}
        >
          {t("Add Overtime")}
        </Button>
      )}
      <Divider />
      <Table columns={columns} dataSource={clientOvertimes} />
    </>
  );
};
export default OvertimeSettings;
